import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import produce from 'immer';
import get from 'lodash/get';
import isNil from 'lodash/isNil';

import { ProblemsActions, ProblemsStore } from 'store/problems/typings';

import * as constants from './constants';

const initialState: ProblemsStore = {
    problems: {},
    problemsLoadingStatus: LOADING_STATUSES.UNSENT,
    problemsInCourses: {},
};

const problemsReducer = (state: ProblemsStore = initialState, action: ProblemsActions) => {
    // eslint-disable-next-line complexity
    return produce(state, (draft) => {
        switch (action.type) {
            case constants.GET_PROBLEMS_REQUEST:
                draft.problemsLoadingStatus = LOADING_STATUSES.LOADING;
                break;

            case constants.GET_PROBLEMS_SUCCESS:
                const { problems, stackId } = action;

                draft.problems[stackId] = problems;
                draft.problemsLoadingStatus = LOADING_STATUSES.SUCCESS;
                break;

            case constants.GET_PROBLEMS_ERROR:
                draft.problemsLoadingStatus = LOADING_STATUSES.ERROR;
                break;

            case constants.GET_PROBLEMS_IN_COURSE_SUCCESS: {
                const { problemsInCourse, courseId } = action;

                draft.problemsInCourses[courseId] = problemsInCourse;
                break;
            }

            case constants.REMOVE_PROBLEM_USAGE: {
                const { courseId, lessonId, problemId } = action;

                const problemUsages = get(state.problemsInCourses, [courseId, problemId]);

                if (isNil(problemUsages)) {
                    return;
                }

                const lessonIndex = state.problemsInCourses[courseId][problemId].findIndex((l) => l.id === lessonId);

                if (lessonIndex !== -1) {
                    if (state.problemsInCourses[courseId][problemId].length === 1) {
                        delete draft.problemsInCourses[courseId][problemId];
                    } else {
                        draft.problemsInCourses[courseId][problemId].splice(lessonIndex, 1);
                    }
                }

                break;
            }

            default:
                break;
        }
    });
};

export default problemsReducer;
